import { SpaceColumns } from '@miq/catalog';
export enum SpaceTermsListener {
  EffectiveRent = 'effective_rent_amount_monthly',
  EffectiveRentUOM = 'effective_rent_amount_monthly_uom',
  AchievableRent = 'achievable_rental_rate_monthly',
  AchievableRentUOM = 'achievable_rental_rate_monthly_uom',
  LeaseTerm = 'minumum_lease_term',
  RentFree = 'number_of_month_free_rent',
  Leasecomps = 'leasecomps',
  AvailableSpace = 'available_space',
  AvailableSpaceUOM = 'available_space_uom_desc',
  RentType = 'area_measurement_type_desc',
  NetRentableArea = 'net_rentable_area',
  NetRentableAreaUOM = 'net_rentable_area_uom',
  SpaceUtilizationEfficiencyRate = 'space_utilization_efficiency_rate',
  AskingRentalRateYearly = 'asking_rental_rate_monthly',
  AskingRentalRateYearlyUOM = 'asking_rental_rate_monthly_uom_desc',
  AskingRentalAmountYearly = 'asking_rental_amount_monthly',
  AskingRentalAmountYearlyUOM = 'asking_rental_amount_monthly_uom',
  AchievableRentAmount = 'achievable_rental_amount_monthly',
  AchievableRentAmountUOM = 'achievable_rental_amount_monthly_uom',
  TotalMonthlyOutgoing = 'maintenence_cost',
  TotalMonthlyOutgoingUOM = 'maintenence_cost_uom',
  ManagementFee = 'cam_charges',
  ManagementFeeUOM = 'cam_charges_uom_desc',
  SpaceStatus = 'ref_space_availability_status_desc',
  Possession = 'ref_possession_type_desc',
  LeaseStartDate = 'arrangement_start_date',
  LeaseEndDate = 'arrangement_end_date',
  LeaseSignedDate = 'arrangement_signed_date',
  LeaseRentalPerArea = 'asking_rent_per_area_value',
  LeaseRentalPerAreaUOM = 'asking_rent_per_area_value_uom_desc',
  // Hong Kong Retail specific fields
  ManagementFeePerMonth = 'cam_charges',
  ManagementFeePerMonthUOM = 'cam_charges_uom_desc',
  ManagementFeePerSqFt = 'cam_charges_per_area_value',
  ManagementFeePerSqFtUOM = 'cam_charges_per_area_value_uom',
  Rental = 'leasecomps/effective_rent_monthly',
  RentalUOM = 'leasecomps/ref_effective_rent_monthly_uom_desc',
  RentalPerSqFt = 'leasecomps/asking_rent_per_area_value',
  RentalPerSqFtUOM = 'leasecomps/asking_rent_per_area_value_uom_desc',
  AirConditioningNormalCharges = 'property_availability_air_condition/standard_charge_rate',
  AirConditioningNormalChargesUOM = 'property_availability_air_condition/standard_charge_rate_uom',
  AirConditioningChargesPerSqFt = 'property_availability_air_condition/charge_rate',
  AirConditioningChargesPerSqFtUOM = 'property_availability_air_condition/charge_rate_uom',
  SalePrice = 'asking_price_for_sale',
  SalePriceUOM = 'asking_price_for_sale_uom_desc',
  SalePriceBySqFt = 'asking_sale_rate',
  SalePriceBySqFtUOM = 'asking_sale_rate_uom',
  LeaseRental = 'effective_rent_monthly',
  LeaseRentalUOM = 'ref_effective_rent_monthly_uom_desc',
  LeaseTitle = 'arrangement_name',
  LayoutCbre = 'layout_cbre_f',
}
export const SpaceTermsColumns = {
  EffectiveRent: SpaceColumns.Terms_EffectiveRent,
  EffectiveRentUOM: SpaceColumns.Terms_EffectiveRentUOM,
  AchievableRent: SpaceColumns.Terms_AchievableRent,
  AchievableRentUOM: SpaceColumns.Terms_AchievableRentUOM,
  LeaseTerm: SpaceColumns.Terms_LeaseTerm,
  RentFree: SpaceColumns.Terms_RentFree,
  AvailableSpace: SpaceColumns.SpaceDetails_SpaceSize,
  AvailableSpaceUOM: SpaceColumns.SpaceDetails_SpaceSizeUOM,
  RentType: SpaceColumns.SpaceDetails_AreaType,
  NetRentableArea: SpaceColumns.SpaceDetails_NetRentableArea,
  NetRentableAreaUOM: SpaceColumns.SpaceDetails_NetRentableAreaUOM,
  SpaceUtilizationEfficiencyRate: SpaceColumns.SpaceDetails_EfficiencyRate,
  AskingRentalRateYearly: SpaceColumns.Terms_AskingRentalRateYearly,
  AskingRentalRateYearlyUOM: SpaceColumns.Terms_AskingRentalRateYearlyUOM,
  AskingRentalAmountYearly: SpaceColumns.Terms_AskingRentalAmountYearly,
  AskingRentalAmountYearlyUOM: SpaceColumns.Terms_AskingRentalAmountYearlyUOM,
  AchievableRentAmount: SpaceColumns.Terms_AchievableRentAmount,
  AchievableRentAmountUOM: SpaceColumns.Terms_AchievableRentAmountUOM,
  TotalMonthlyOutgoing: SpaceColumns.Terms_TotalMonthlyOutgoing,
  TotalMonthlyOutgoingUOM: SpaceColumns.Terms_TotalMonthlyOutgoingUOM,
  // HKG Industrial Total Monthly Outgoings
  TotalMonthlyOutgoingsHKGIndustrial: SpaceColumns.Terms_TotalMonthlyOutgoingsHKGIndustrial,
  TotalMonthlyOutgoingsHKGIndustrialUOM: SpaceColumns.Terms_TotalMonthlyOutgoingsHKGIndustrialUOM,
  ManagementFee: SpaceColumns.Terms_ManagementFee,
  ManagementFeeUOM: SpaceColumns.Terms_ManagementFeeUOM,
  LeaseStartDate: SpaceColumns.SpaceDetails_LeaseStartDate,
  LeaseEndDate: SpaceColumns.SpaceDetails_LeaseEndDate,
  ManagementFeePerMonth: SpaceColumns.ManagementFee_PerMonth,
  ManagementFeePerMonthUOM: SpaceColumns.ManagementFee_PerMonthUOM,
  ManagementFeePerSqFt: SpaceColumns.ManagementFee_PerSqFt,
  ManagementFeePerSqFtUOM: SpaceColumns.ManagementFee_PerSqFtUOM,
  Rental: SpaceColumns.LeaseTerms_Rental,
  RentalUOM: SpaceColumns.LeaseTerms_RentalUOM,
  RentalPerSqFt: SpaceColumns.SpaceDetails_RentalPersf,
  RentalPerSqFtUOM: SpaceColumns.SpaceDetails_RentalPersfUom,
  AirConditioningNormalCharges: SpaceColumns.AirConditioning_NormalCharges,
  AirConditioningNormalChargesUOM: SpaceColumns.AirConditioning_NormalChargesUOM,
  AirConditioningChargesPerSqFt: SpaceColumns.AirConditioning_ChargesPerSqFt,
  AirConditioningChargesPerSqFtUOM: SpaceColumns.AirConditioning_ChargesPerSqFtUOM,
  SalePrice: SpaceColumns.SalesDetails_SalePrice,
  SalePriceUOM: SpaceColumns.SalesDetails_SalePriceUOM,
  SalePriceBySqFt: SpaceColumns.SalesDetails_SalePriceBySqFt,
  SalePriceBySqFtUOM: SpaceColumns.SalesDetails_SalePriceBySqFtUOM,
  HKRetailAskingRentalAmount: SpaceColumns.RentalDetails_AskingRentalAmountMonthly,
  HKRetailAskingRentalAmountUOM: SpaceColumns.RentalDetails_AskingRentalAmountMonthlyUOM,
  HKRetailAskingRentalRate: SpaceColumns.RentalDetails_AskingRentalRateMonthly,
  HKRetailAskingRentalRateUOM: SpaceColumns.RentalDetails_AskingRentalRateMonthlyUOM,
};
/**
 * Space status and possession values for conditional logic
 */
export const enum SpaceConditionValues {
  LEASED = 'leased',
  TENANT_OCCUPIED = 'tenant occupied',
  FUTURE_VACANCY = 'future vacancy',
  Surrender_Sublet = 'surrender/sublet',
  OWNER_OCCUPIED = 'owner occupied',
}
/**
 * Possession values that should be excluded from triggering lease arrangement updates
 */
export const EXCLUDED_POSSESSION_VALUES = [
  SpaceConditionValues.TENANT_OCCUPIED,
  SpaceConditionValues.FUTURE_VACANCY,
  SpaceConditionValues.Surrender_Sublet,
  SpaceConditionValues.OWNER_OCCUPIED,
] as const;
/**
 * Space lease terms constants for enabling/disabling functionality
 */
export const SPACE_LEASE_TERMS_CONFIG = {
  ENABLED_CONDITIONS: {
    SPACE_STATUS: SpaceConditionValues.LEASED,
    POSSESSION: [
      SpaceConditionValues.TENANT_OCCUPIED,
      SpaceConditionValues.FUTURE_VACANCY,
      SpaceConditionValues.Surrender_Sublet,
      SpaceConditionValues.OWNER_OCCUPIED,
    ],
  },
  FIELD_NAMES: {
    SPACE_STATUS: SpaceTermsListener.SpaceStatus,
    POSSESSION: SpaceTermsListener.Possession,
  },
} as const;
export const SPACE_TENANCY_COMMENTS_COLUMNS = [
  SpaceColumns.Space_Tenancy_Comment,
  SpaceColumns.Space_Tenancy_UserEmail,
  SpaceColumns.Space_Tenancy_UserName,
  SpaceColumns.Space_Tenancy_Comment_DT,
  SpaceColumns.Space_Tenancy_CommentType,
];
export const enum SPACE_TENANCT_DETAILS {
  TENANT_DETAIL = 'tenant_detail',
  TENANT_REF = 'tenant_ref',
}
export const SPACE_TENANT_DETAILS_COLUMNS = {
  RentReviewDate: 'leasecomps/arrangement_options/arrangement_option_start_date',
  CompanyNames: 'leasecomps/company_contact_role_addresses/company_name',
};
